import React, { FC } from 'react';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { useParams } from 'react-router-dom';
import { DocumentsUploaderPage } from '../../../components/application/quick-application/DocumentsUploaderPage';
import { fetchMerchantData, setMerchantDocuments } from '../../../store/merchnts/actions/merchant';

export const MerchantDocumentsPage: FC = () => {
  const { id } = useParams<{ id: string }>();

  const {
    merchantState: { isMerchantDataLoading, merchantData },
    dispatch
  } = useMerchants();

  const showPlaceholder = !merchantData || typeof merchantData === 'object' && Object.keys(merchantData).length === 0 || typeof merchantData !== 'object';

  return (
    <DocumentsUploaderPage
      showPlaceholder={showPlaceholder}
      id={id}
      dataUploadedDocuments={merchantData?.uploadedDocuments}
      enableEditBlock={true}
      setDocuments={setMerchantDocuments}
      onEditSuccess={async (): Promise<void> => await fetchMerchantData(dispatch, id)}
      tableLoading={isMerchantDataLoading}
      enableToDelete
    />
  );
};
